export const availableColors = [
    {
      "value": "Black",
      "label": "Black",
      "color": "#000000"
    },
    {
      "value": "Blood Orange Translucent",
      "label": "Blood Orange Translucent",
      "color": "#913E30"
    },
    {
      "value": "Blood Orange",
      "label": "Blood Orange",
      "color": "#901717"
    },
    {
      "value": "Clear",
      "label": "Clear",
      "color": "#9F9C84"
    },
    {
      "value": "Cloud Translucent",
      "label": "Cloud Translucent",
      "color": "#8E9AA8"
    },
    {
      "value": "Dark Purple",
      "label": "Dark Purple",
      "color": "#24253F"
    },
    {
      "value": "Forest Green",
      "label": "Forest Green",
      "color": "#255048"
    },
    {
      "value": "Granny Smith Translucent",
      "label": "Granny Smith Translucent",
      "color": "#21710F"
    },
    {
      "value": "Honey Translucent",
      "label": "Honey Translucent",
      "color": "#AB6C25"
    },
    {
      "value": "Lime Translucent",
      "label": "Lime Translucent",
      "color": "#487A59"
    },
    {
      "value": "Metallic Blue Translucent",
      "label": "Metallic Blue Translucent",
      "color": "#124D50"
    },
    {
      "value": "Metallic Bronze",
      "label": "Metallic Bronze",
      "color": "#4F492F"
    },
    {
      "value": "Metallic Silver",
      "label": "Metallic Silver",
      "color": "#3E443F"
    },
    {
      "value": "Navy Blue Translucent",
      "label": "Navy Blue Translucent",
      "color": "#304D96"
    },
    {
      "value": "Navy Blue",
      "label": "Navy Blue",
      "color": "#224088"
    },
    {
      "value": "Orange",
      "label": "Orange",
      "color": "#B0361B"
    },
    {
      "value": "Pink Translucent",
      "label": "Pink Translucent",
      "color": "#B86E6C"
    },
    {
      "value": "Pink",
      "label": "Pink",
      "color": "#FF7695"
    },
    {
      "value": "Radioactive Translucent",
      "label": "Radioactive Translucent",
      "color": "#91D083"
    },
    {
      "value": "Red",
      "label": "Red",
      "color": "#96212F"
    },
    {
      "value": "Sangria",
      "label": "Sangria",
      "color": "#6E2746"
    },
    {
      "value": "Sea Blue Translucent",
      "label": "Sea Blue Translucent",
      "color": "#5A5C8E"
    },
    {
      "value": "Sky Blue",
      "label": "Sky Blue",
      "color": "#657CAF"
    },
    {
      "value": "Translucent Red",
      "label": "Translucent Red",
      "color": "#AF3130"
    },
    {
      "value": "Turquoise Translucent",
      "label": "Turquoise Translucent",
      "color": "#287791"
    },
    {
      "value": "Turquoise",
      "label": "Turquoise",
      "color": "#559BCF"
    },
    {
      "value": "Violet Translucent",
      "label": "Violet Translucent",
      "color": "#903467"
    },
    {
      "value": "Violet",
      "label": "Violet",
      "color": "#411E28"
    },
    {
      "value": "White",
      "label": "White",
      "color": "#EBE7D7"
    },
    {
      "value": "Yellow Translucent",
      "label": "Yellow Translucent",
      "color": "#BCB335"
    },
    {
      "value": "Yellow",
      "label": "Yellow",
      "color": "#DDD221"
    }
  ];